import React from "react";
import "../css/arrival.css";
import { checkedData } from "../rawData/MenuData";
import  { useState, useEffect } from "react";
import {  RiArrowDownSFill } from "react-icons/ri";

const BrandList = () => {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    setUsers(checkedData);
  }, []);

  const handleChange = (e) => {
    const { name, checked } = e.target;
    if (name === "allSelect") {
      let tempUser = users.map((user) => {
        return { ...user, isChecked: checked };
      });
      setUsers(tempUser);
    } else {
      let tempUser = users.map((user) =>
        user.name === name ? { ...user, isChecked: checked } : user
      );
      setUsers(tempUser);
    }
  };
  return (
    <>
      <div className="sideBox ">
        <ul className="border-top ">
          <button
            className="brandbtn"
            type="button"
            data-toggle="collapse"
            data-target="#brand"
          >
            Brands <RiArrowDownSFill />
          </button>
          <div id="brand" class="collapse show">
            <form>
              <div class="form-check pl-3">
                <label class="form-check-label">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    value=""
                    name="allSelect"
                    checked={!users.some((user) => user?.isChecked !== true)}
                    onChange={handleChange}
                  />
                  Select All
                </label>
              </div>
              <div>
                <ul className="scroll-control">
                  {users.map((user) => (
                    <li>
                      <a>
                        <input
                          type="checkbox"
                          className="mr-2 "
                          name={user.name}
                          checked={user?.isChecked || false}
                          onChange={handleChange}
                        />
                        <span>{user.name} </span>
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </form>
          </div>
        </ul>
      </div>
    </>
  );
};

export default BrandList;
